import { useCallback, useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import Dialog from "components/DesignComponents/Dialog";
import AuthContext from "context/auth/authContext";
import { COOKIE_NAMES } from "shared/types/enums";

import { CookiesMainDescription } from "./components/CookiesMainDescription";
import { CookiesModalContent } from "./components/CookiesModalContent";
import { CookiesModalProps } from "./types/interfaces";
import { CookieButtonType } from "./types/types";

const CookiesModal = ({
    isOpen,
    onClose,
    setShowBanner
}: CookiesModalProps) => {
    const { setCookieConsent } = useContext(AuthContext);
    const { t } = useTranslation();

    const [isAnalyticsCookies, setIsAnalyticsCookies] = useState(false);

    const handleCloseDialog = useCallback(() => {
        onClose(false);
    }, [onClose]);

    const handleOnlyEssentialCookies = () => {
        setCookieConsent(COOKIE_NAMES.All, false);
        handleCloseDialog();
        setShowBanner(false);
    };

    const handleAcceptSelected = () => {
        setCookieConsent(COOKIE_NAMES.All, isAnalyticsCookies);
        handleCloseDialog();
        setShowBanner(false);
    };

    const COOKIE_MODAL_ACTION_BUTTONS: CookieButtonType[] = [
        {
            color: BUTTON_COLORS.Primary,
            buttonText: t("Button##only essential"),
            action: handleOnlyEssentialCookies
        },
        {
            color: BUTTON_COLORS.Primary,
            buttonText: t("Button##accept selected"),
            action: handleAcceptSelected
        }
    ];

    return (
        <Dialog
            title={t("Cookies##cookie modal title")}
            description={<CookiesMainDescription />}
            open={isOpen}
            close={handleCloseDialog}
            isTitleSeparator
            isActionsSeparator
            disablePortal
            actions={
                <>
                    {COOKIE_MODAL_ACTION_BUTTONS.map(
                        (button: CookieButtonType) => (
                            <Button
                                key={button.buttonText}
                                fullWidth
                                color={button.color}
                                size={BUTTON_SIZES.Normal}
                                variant={BUTTON_VARIANTS.TextOnly}
                                onClick={button.action}
                            >
                                {button.buttonText}
                            </Button>
                        )
                    )}
                </>
            }
            slotProps={{
                backdrop: {
                    invisible: true
                },
                transition: {
                    onExited: () => setIsAnalyticsCookies(false)
                }
            }}
        >
            <CookiesModalContent
                setIsAnalyticsCookies={setIsAnalyticsCookies}
                isAnalyticsCookies={isAnalyticsCookies}
            />
        </Dialog>
    );
};

export default CookiesModal;
